export var MissionCategory;
(function (MissionCategory) {
    MissionCategory["ENGAGEMENT"] = "ENGAGEMENT";
    MissionCategory["TRANSACTION"] = "TRANSACTION";
    MissionCategory["SOCIAL"] = "SOCIAL";
    MissionCategory["SURVEY"] = "SURVEY";
})(MissionCategory || (MissionCategory = {}));
export var MissionStatus;
(function (MissionStatus) {
    MissionStatus["AVAILABLE"] = "AVAILABLE";
    MissionStatus["COMPLETED"] = "COMPLETED";
    MissionStatus["EXPIRED"] = "EXPIRED";
    MissionStatus["IN PROGRESS"] = "IN PROGRESS";
    MissionStatus["NEW"] = "NEW";
})(MissionStatus || (MissionStatus = {}));
export var FieldType;
(function (FieldType) {
    FieldType["TEXT_SINGLE"] = "text-single-survey-question";
    FieldType["TEXT_MULTIPLE"] = "text-multiple-survey-question";
    FieldType["TEXT_MULTIPLE_AND_OPEN"] = "text-multiple-and-open-survey-question";
    FieldType["IMAGE_SINGLE"] = "image-single-survey-question";
    FieldType["IMAGE_MULTIPLE"] = "image-multiple-survey-question";
    FieldType["OPEN"] = "open-survey-question";
    FieldType["TEXT_ANSWER"] = "text-survey-answer";
    FieldType["TEXT_AND_OPEN_ANSWER"] = "text-and-open-survey-answer";
    FieldType["IMAGE_ANSWER"] = "image-survey-answer";
    FieldType["OPEN_ANSWER"] = "open-survey-answer";
})(FieldType || (FieldType = {}));
//# sourceMappingURL=missions.types.js.map